// @ts-nocheck
import { scarpaGray800 } from '@habitech/shared';
import styled from 'styled-components';

export const Label = styled.p`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
    color: ${scarpaGray800};
    margin:  16px 0 0;

`
